import React from 'react';
import KoobTitle from '../../../components/Koob/KoobTitle';
import { useTranslation } from 'react-i18next';
import LibraryFilters from '../Library/LibraryFilters';
import LibraryActiveFilters from '../Library/LibraryActiveFilters';
import TripCard from 'components/Trip/TripCard';
import TripList, { buildTripRequestFilters } from 'components/Trip/TripList';
import KoobLayout from '../../../components/Koob/KoobLayout';
import { PER_PAGE_FOR_CATALOG } from '../../../constants';
import { useLibraryFilters } from '@koob/trip-designer';

export default function DistributedTrips() {
  const { t } = useTranslation('tripDesigner');
  const libraryFilters = useLibraryFilters();

  return (
    <KoobLayout>
      <div className="flex flex-col">
        <LibraryFilters isDmcTrips />

        <LibraryActiveFilters style={{ marginTop: '1rem' }} />

        <div className="flex flex-row place-content-between">
          <KoobTitle size="text-2xl">{t('dmcTemplates.title')}</KoobTitle>
        </div>

        <div className="mt-3">
          <TripList
            perPage={PER_PAGE_FOR_CATALOG}
            filters={buildTripRequestFilters(libraryFilters, {
              type: 'template',
              isDistributedTrip: true,
              // libraryFilters is shared with the library page, and this page
              // hides the author and archive controls: a value set there would
              // silently empty this list (DMC templates have DMC authors, and
              // archived ones are never distributed).
              userId: undefined,
              withArchived: false,
            })}
            renderCount={count => (
              <h6 className="mt-4 mb-3 text-gray-500">
                {t('dmcTemplates.results', { count })}
              </h6>
            )}
            renderCard={(trip, reload) => (
              <TripCard
                trip={trip}
                reload={reload}
                enableExport
                isDistributedTrip
              />
            )}
          />
        </div>
      </div>
    </KoobLayout>
  );
}
